import { Container, H3, P1, useWindowSize } from '@moneymade/moneymade-ui'
import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import PropTypes from 'prop-types'
import { TwitterTimelineEmbed } from 'react-twitter-embed'

import { getCdnImg } from 'utils/getters'
import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import styles from './Twitter.module.scss'

const Twitter = ({ urlSlug, title, titleInvest, investInfo, twitt }) => {
  const { screenWidth } = useWindowSize()
  return (
    <Container width={1230} className={styles.Twitter}>
      <div className={styles.Left}>
        <H3 weight="semibold" id={urlSlug}>
          {title}
        </H3>

        {twitt.map(({ code, twittBy }, index) => (
          <div key={index} className={`twitter ${styles.Code}`}>
            {twittBy ? (
              <TwitterTimelineEmbed sourceType="profile" screenName={twittBy} options={{ height: 600, width: 538 }} />
            ) : (
              <div nestedStyles dangerouslySetInnerHTML={{ __html: code }} />
            )}
          </div>
        ))}
      </div>
      <div className={styles.Right}>
        <H3 weight="semibold">{titleInvest}</H3>
        <div className={styles.People}>
          {screenWidth > 961 ? (
            investInfo.map(({ name, positionInCompany, text, image }, index) => (
              <div key={index} className={styles.Person}>
                <ImgLazy src={getCdnImg(image, 95)} alt={name} width={96} height={96} />

                <div className={styles.Content}>
                  <P1 weight="semibold" className={styles.Name}>
                    {name}
                  </P1>
                  <P1 weight="light" className={styles.Text}>
                    {positionInCompany}
                  </P1>
                  <P1 weight="light" className={styles.Description}>
                    {text}
                  </P1>
                </div>
              </div>
            ))
          ) : (
            <Swiper
              className={styles.SwiperCards}
              modules={[Pagination]}
              spaceBetween={24}
              pagination={{ clickable: true }}
              breakpoints={{
                890: {
                  slidesPerView: 2.5
                },
                600: {
                  slidesPerView: 2.5
                },
                0: {
                  slidesPerView: 1.17
                }
              }}
            >
              {investInfo?.map(({ name, positionInCompany, text, image }, index) => (
                <SwiperSlide key={`indystry-${index}`}>
                  <div className={styles.PersonSwipe}>
                    <div className={styles.Header}>
                      <ImgLazy src={getCdnImg(image, 72)} alt={name} width={72} height={72} />

                      <div className={styles.TextContent}>
                        <P1 weight="semibold" className={styles.Name}>
                          {name}
                        </P1>
                        <P1 weight="light" className={styles.Text}>
                          {positionInCompany}
                        </P1>
                      </div>
                    </div>
                    <P1 weight="light" className={styles.Description}>
                      {text}
                    </P1>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </Container>
  )
}

Twitter.propTypes = {
  title: PropTypes.string,
  urlSlug: PropTypes.string,
  titleInvest: PropTypes.string,
  investInfo: PropTypes.arrayOf(PropTypes.object),
  twitt: PropTypes.arrayOf(PropTypes.object)
}

Twitter.defaultProps = {
  title: '',
  urlSlug: '',
  titleInvest: '',
  investInfo: [],
  twitt: []
}

export default Twitter
